// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2UWIa","content":"styles_content___zt8a","selectAll":"styles_selectAll__aCrzG"};